export default __webpack_public_path__ + "static/media/336.2f51c751.png";